import * as yup from "yup";

import { EMAIL_REGEX } from "../constants";

export const NewEnrollmentSchema = yup.object({
  npi: yup.string().when({
    is: (val: string) => val && val.length > 0,
    then: (schema) =>
      schema
        .test("containAllDigits", "NPI should only contain digits", (val) =>
          val ? /^\d+$/.test(val) : false
        )
        .min(10, "NPI Invalid")
        .max(10, "NPI Invalid"),
  }),

  enrollment_practices_attributes: yup
    .array()
    .of(
      yup.object({
        practice_name: yup
          .string()
          .required(`Practice Name is required`)
          .max(120, `Practice Name should only be 120 characters long`),
        npi: yup
          .string()
          .required(`NPI  is required `)
          .test("containAllDigits", "NPI should only contain digits", (val) =>
            val ? /^\d+$/.test(val) : false
          )
          .min(10, `NPI Invalid`)
          .max(10, `NPI Invalid`),
        tax: yup.string().max(9, `Tax Id Invalid`),
        // phone_number: yup
        //   .string()
        //   .required(`Phone Number is required`)
        //   .min(10, `Phone Number Invalid`)
        //   .max(10, `Phone Number Invalid`)
        //   .test("range", "Phone Number Invalid", (val) => {
        //     const numberedVal = Number(val);
        //     if (!isNaN(numberedVal)) {
        //       if (numberedVal > 2000000000 && numberedVal < 9999999999)
        //         return true;
        //     }
        //     return false;
        //   }),
        phone_number: yup
          .string()
          .required("Phone Number is required")
          .matches(
            /^(?!555)[1-9][0-9]{2}(?!555)[1-9][0-9]{6}$/,
            "Phone Number Invalid"
          )
          .min(10, "Phone Number Invalid")
          .max(10, "Phone Number Invalid"),
          // .test("range", "Phone Number Invalid", (val) => {
          //   if (!val) return false;
          //   const numberedVal = Number(val);
          //   return (
          //     !isNaN(numberedVal) &&
          //     numberedVal > 2000000000 &&
          //     numberedVal < 9999999999
          //   );
          // }),
        // fax_number: yup
        //   .string()
        //   .required(`Fax Number is required`)
        //   .min(10, `Fax Number Invalid`)
        //   .max(10, `Fax Number Invalid`)
        //   .test("range", "Fax Number Invalid", (val) => {
        //     const numberedVal = Number(val);
        //     if (!isNaN(numberedVal)) {
        //       if (numberedVal > 2000000000 && numberedVal < 9999999999)
        //         return true;
        //     }
        //     return false;
        //   }),
        fax_number: yup
          .string()
          .required("Fax Number is required")
          .matches(
            /^(?!555)[1-9][0-9]{2}(?!555)[1-9][0-9]{6}$/,
            "Fax Number Invalid"
          ),
          // .test("range", "Fax Number Invalid", (val) => {
          //   if (!val) return false;
          //   const numberedVal = Number(val);
          //   return (
          //     !isNaN(numberedVal) &&
          //     numberedVal > 2000000000 &&
          //     numberedVal < 9999999999
          //   );
          // }),
        street: yup.string().required(`Street is required`),
        suite: yup.string(),
        city: yup.string().required(`City is required`),
        state: yup.string().required(`State is required`),
        zip: yup
          .string()
          .required(`Zip code is required`)
          .min(5, `Zip Invalid`)
          .max(5, `Zip should only be 5 characters long`)
          .test(
            "containAllDigits",
            "Zip code should only contain digits",
            (val) => (val ? /^\d+$/.test(val) : false)
          ),
      })
    )
    .required(`Practice data is required`),

  enrollment_contacts_attributes: yup
    .array()
    .of(
      yup.object({
        firstname: yup
          .string()
          .required(`First name is required`)
          .max(35, `Name should only be 35 characters long`),
        lastname: yup
          .string()
          .required(`Last name is required`)
          .max(35, `Name should only be 35 characters long`),
        middlename: yup
          .string()
          .max(35, `Name should only be 35 characters long`),
        email: yup
          .string()
          .required(`Email is required`)
          .test("EmailVerification", `Email Invalid`, (val) =>
            EMAIL_REGEX.test(val)
          ),
      })
    )
    .required(`User data is required`),

  enrollment_doctors_attributes: yup
    .array()
    .of(
      yup.object({
        npi: yup
          .string()
          .required(`NPI is required`)
          .test("containAllDigits", "NPI should only contain digits", (val) =>
            val ? /^\d+$/.test(val) : false
          )
          .min(10, `NPI Invalid`)
          .max(10, `NPI Invalid`),
        tax_id: yup.string().max(9, `Tax ID Invalid`),
        firstname: yup
          .string()
          .required(`First name is required`)
          .max(35, `Name should only be 35 characters long`),
        lastname: yup
          .string()
          .required(`Last name must be present`)
          .max(35, `Name should only be 35 characters long`),
        middlename: yup
          .string()
          .max(35, `Name should only be 35 characters long`),
        ref_taxonomy_id: yup.string().required(`Taxonomy is required`),
         phone_number: yup
          .string()
          .required("Phone Number is required")
          .matches(
            /^(?!555)[1-9][0-9]{2}(?!555)[1-9][0-9]{6}$/,
            "Phone Number Invalid"
          )
          .min(10, "Phone Number Invalid")
          .max(10, "Phone Number Invalid"),
          // .test("range", "Phone Number Invalid", (val) => {
          //   if (!val) return false;
          //   const numberedVal = Number(val);
          //   return (
          //     !isNaN(numberedVal) &&
          //     numberedVal > 2000000000 &&
          //     numberedVal < 9999999999
          //   );
          // })
          // ,
        // phone_number: yup
        //   .string()
        //   .required(`Phone Number is required`)
        //   .min(10, `Phone Number Invalid`)
        //   .max(10, `Phone Number Invalid`)
        //   .test("range", "Phone Number Invalid", (val) => {
        //     const numberedVal = Number(val);
        //     if (!isNaN(numberedVal)) {
        //       if (numberedVal > 2000000000 && numberedVal < 9999999999)
        //         return true;
        //     }
        //     return false;
        //   }),
        // fax_number: yup
        //   .string()
        //   .required(`Fax Number is required`)
        //   .min(10, `Fax Number Invalid`)
        //   .max(10, `Fax Number Invalid`)
        //   .test("range", "Fax Number Invalid", (val) => {
        //     const numberedVal = Number(val);
        //     if (!isNaN(numberedVal)) {
        //       if (numberedVal > 2000000000 && numberedVal < 9999999999)
        //         return true;
        //     }
        //     return false;
        //   }),
         fax_number: yup
          .string()
          .required("Fax Number is required")
          .matches(
            /^(?!555)[1-9][0-9]{2}(?!555)[1-9][0-9]{6}$/,
            "Fax Number Invalid"
          ),
          // .test("range", "Fax Number Invalid", (val) => {
          //   if (!val) return false;
          //   const numberedVal = Number(val);
          //   return (
          //     !isNaN(numberedVal) &&
          //     numberedVal > 2000000000 &&
          //     numberedVal < 9999999999
          //   );
          // }),
        // dea: yup
        //   .string()
        //   .when({
        //     is: (val:string) => val && val.length > 0,
        //     then: (schema) =>
        //       schema
        //         .min(9, "DEA Invalid")
        //         .max(9, "Dea exceeds char limit")
        //         .test('CheckForInvalidChars', 'DEA Invalid', (val) => (val ? /^[ABDEFGHJKLMPRSTUX][A-Z0-9]\d{6}\d$/.test(val) : true)),
        //   }),
        // dea: yup
        //   .string()
        //   .trim()
        //   .matches(
        //     /^[ABDEFGHJKLMPRSTUX][A-Z0-9]\d{7}$/,
        //     "DEA Invalid"
        //   )
        //   .test("valid-checksum", "DEA Invalid", (value) => {
        //     if (!value) return true;
        //     const digits = value.slice(2).split("").map(Number);
        //     if (digits.some(isNaN)) return false;

        //     const sum1 = digits[0] + digits[2] + digits[4];
        //     const sum2 = (digits[1] + digits[3] + digits[5]) * 2;
        //     const checksum = (sum1 + sum2) % 10;

        //     return digits[6] === checksum;
        //   }),
        dea: yup
          .string()
          .trim()
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema
                .min(9, "DEA Invalid")
                .max(9, "Dea exceeds char limit")
                .matches(/^[ABDEFGHJKLMPRSTUX][A-Z0-9]\d{7}$/, "DEA Invalid")
                .test("valid-checksum", "DEA Invalid", (value) => {
                  if (!value) return true;

                  const digits = value.slice(2).split("").map(Number);
                  if (digits.some(isNaN)) return false;

                  const sum1 = digits[0] + digits[2] + digits[4]; //15
                  const sum2 = (digits[1] + digits[3] + digits[5]) * 2; //36
                  const checksum = (sum1 + sum2) % 10;

                  return digits[6] === checksum;
                }),
          }),
        sln: yup.string(),
        ptan: yup.string(),
        email: yup
          .string()
          .test(
            "EmailVerification",
            `Provided value should be a valid email`,
            (val) => (val ? EMAIL_REGEX.test(val) : true)
          ),
      })
    )
    .required(`Prescriber data is required`),
});
